import { Routes } from '@angular/router';
import {StatementsList} from './statements-list/statements-list';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LayoutService } from '../../../services/layout.service';

export const statementsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => StatementsList,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Extrato`;
    }
  },
];
